/** Frontend workday gate constants — keep in sync with backend/constants/workdayConstants.js */

export const WORKDAY_GATED_ROLES = [
    'Salesman',
    'ASM',
    'ZSM',
    'RSM',
    'NSM',
    'AccountsStaff',
    'Accountant',
    'WarehouseStaff',
    'HRManager',
];

export const WORKDAY_STEPS = {
    PENDING_CHECKOUT: 'pending_checkout',
    PENDING_DAILY_CLOSING: 'pending_daily_closing',
    PENDING_CHECKIN: 'pending_checkin',
    PENDING_WORKING_DISTRIBUTOR: 'pending_working_distributor',
    CLEAR: 'clear',
};

export const WORKDAY_PATHS = {
    [WORKDAY_STEPS.PENDING_CHECKOUT]: '/workday/pending-checkout',
    [WORKDAY_STEPS.PENDING_DAILY_CLOSING]: '/workday/pending-closing',
    [WORKDAY_STEPS.PENDING_CHECKIN]: '/workday/check-in',
    [WORKDAY_STEPS.PENDING_WORKING_DISTRIBUTOR]: '/workday/working-distributor',
};

export function isWorkdayGatedRole(role) {
    return WORKDAY_GATED_ROLES.includes(role);
}

/**
 * Roles that may carry a daily Working Distributor Session.
 * Keep in sync with backend/services/workingDistributorSessionService.js.
 * Salesman is hard-gated (must select before working); ASM/ZSM get an
 * optional chip-driven switcher in the header — never a blocking gate.
 */
export const MULTI_DISTRIBUTOR_ROLES = ['Salesman', 'ASM', 'ZSM'];

export function isMultiDistributorRole(role) {
    return MULTI_DISTRIBUTOR_ROLES.includes(role);
}

export function isWorkdayExemptPath(pathname = '') {
    if (!pathname) return false;
    if (pathname.startsWith('/workday')) return true;
    if (pathname.startsWith('/login') || pathname.startsWith('/signin')) return true;
    if (pathname.startsWith('/forgot-password') || pathname.startsWith('/reset-password')) return true;
    // Allow completing daily closing from the dedicated gate screen (embedded / deep link)
    if (pathname.startsWith('/operations/daily-closing')) return true;
    return false;
}

export const WORKDAY_THEME = {
    primary: '#09b8a9',
    primaryDark: '#078d82',
    secondary: '#383b50',
    bg: '#f5f8f7',
    panel: '#ffffff',
    border: '#e5edec',
    text: '#383b50',
    textSec: '#6b7280',
    danger: '#c0392b',
    warning: '#b45309',
};
